Ext.ns('mx.comp');

mx.comp.NonVisual = Ext.extend(Ext.Component, {
    nonVisual: true,
    onRender: function(ct, position) {
        if (!mx.comp.NonVisual.divDumbContent) {
            mx.comp.NonVisual.divDumbContent = Ext.getBody().createChild({tag: 'div', id: 'nonVisualComponent'});
            mx.comp.NonVisual.divDumbContent.setVisible(false);
        }
        this.el = mx.comp.NonVisual.divDumbContent;
    },
});
